<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <div class="b-center-container">
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText2"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText2: '',
    };
  },
  mounted () {
    this.richText2 = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Electron Microscopy & Imaging Unit</span></p>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:75%; height:100%;">'
      + '<p style="margin-bottom : 20px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Electron Microscopy & Imaging Unit is equipped with 50 sets of highly sophisticated and interdisciplinary instruments, sample preparation systems and pretreatment systems. The Unit’s faculty consists of 10 Ph.D graduates and 9 Master graduates. Supported by the advanced multi-scale, multi-dimensional, multi-model analysis platform, the unit is capable to provide the analysis service as follows:<br>'
      + 'a) microstructure observation and element analysis from nanometer to centimeter scale <br>'
      + 'b) physical properties characterization of mechanical property, magnetic property, electrical property, optical property and etc. on micro-nano scale <br>'
      + 'c) complex sample preparation, such as FIB <br>'
      + 'd) 3D reconstructing and In situ experiments under the condition of varied temperature, tensile loading , and compressive loading <br>'
      + 'e) 2D and 3D imaging on subcellular level, cellular level and tissue level; <br>'
      + 'f) multimodal in vivo imaging.</span></p>'
      + '</div>'

      + '<div id="right" style="float:left ; width:25%; height:100%;">'
      + '<p style="margin-left : 40px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/yanhuazhu.jpg" style="float: left; width: 200px; margin-right: 30px; margin-top:20px;" border="0" vspace="0" alt=""></p>'
      + '<p style="margin-left:50px;text-align: justify"><span style="font-size: 16px;"><b>Director: Yanhua Zhu</b></span></p>'
      + '</div>'
      + '<p>&nbsp;</p>'

      + '<div>'
      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> &nbsp;&nbsp;&nbsp;TEM analysis system&nbsp;&nbsp;&nbsp; </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment：field-emission TEM, X-ray microscope, Ultramicrotome System (Cryo)</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services：Ultrastructure analysis, Electron Diffraction Analysis, 3D Reconstructing Analysis of Bio-macromolecular</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> &nbsp;&nbsp;&nbsp;SEM analysis system &nbsp;&nbsp;&nbsp;</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment：Field-emission SEM, FIB-SEM, Sample Preparation System</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: Microstructure Analysis, Element analysis, EBSD Analysis, FIB Processing</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> &nbsp;&nbsp;&nbsp;AFM analysis system&nbsp;&nbsp;&nbsp; </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment：Bio-fastscan AFM, Environment Control Scanning Probe Microscope</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: Microstructure Characterization on Micro-nano Scale, Characterization of Mechanical, Magnetic and Electrical Properties</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> &nbsp;&nbsp;&nbsp;Molecular Imaging analysis&nbsp;&nbsp;&nbsp;</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment：Confocal Laser Scanning Microscope, in vivo MRI, in vivo PET/CT</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: 2D and 3D Imaging of Molecular, Cell, Tissue and Live Animal’s Structure, Function and Physical Structure</span></p>'

      + '<p style="text-align: center;"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/electron_microscopy_imaging_en_1.jpg" style="float: left; width: 800px; " border="0" vspace="0" ></p>'

      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">Contact</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Yanhua Zhu</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: zhuyanhua@sjtu.edu.cn</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Tel: +86-021-34208498-6204</span></p>'

      + '</div>'

      + '<p>&nbsp;</p><p>&nbsp;</p>'
},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service13/en/index.vue